import { Dropdown } from '@ami/react/core';
import { FormCheckBox } from '@ami/react/core';
import { FormDropdown } from '@ami/react/core';
import { DealerBranchSetting } from '../../../dealer-users/dealerUserService';
import AuthorizedDealerBranchSettingCard from './AuthorizedDealerBranchSettingCard';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Alert, FormGroup, Input, Label } from 'reactstrap';

export default class AuthorizedDealerGroupSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedId: '',
      expanded: false,
      authorizedDealerBranches: [],
      unAuthorizedDealerBranches: [],
    };

    this.handleExpand = this.handleExpand.bind(this);
    this.removeGroup = this.removeGroup.bind(this);
    this.onChangeIsDealerAdmin = this.onChangeIsDealerAdmin.bind(this);
  }

  static defaultProps = {
    dealerBranchSettings: [],
    permissions: { dealerBranch: [] },
    enabledRemove: true,
  };

  static propTypes = {
    dealerBranches: PropTypes.array.isRequired,
    permissions: PropTypes.object.isRequired,
    dealerGroup: PropTypes.object,
    handleAuthorizedDealerGroupSettingChanged: PropTypes.func.isRequired,
    expanded: PropTypes.bool,
    enabledRemove: PropTypes.bool,
  };

  async componentDidMount() {
    this.setState({ expanded: this.props.expanded });
  }

  handleExpand() {
    this.setState({ expanded: !this.state.expanded });
  }

  removeGroup() {
    this.props.handleRemoveGroup(this.props.dealerGroup.dealerGroupId);
  }

  static getDerivedStateFromProps(props, state) {
    const authorizedDealerBranches =
      props.dealerBranchAuthorization === undefined
        ? []
        : props.dealerBranchAuthorization;
    const unAuthorizedDealerBranches =
      props.dealerBranchAuthorization === undefined
        ? props.dealerBranches
        : props.dealerBranches.filter(
            (el) =>
              !props.dealerBranchAuthorization.some(
                (e) => e.dealerBranchId === el.dealerBranchId
              )
          );

    return {
      authorizedDealerBranches,
      unAuthorizedDealerBranches,
    };
  }

  handleAddDealerBranch = (selectedId) => {
    const selectedDealerBranch = this.state.unAuthorizedDealerBranches.find(
      (x) => x.dealerBranchId === selectedId
    );
    const dealerBranchSetting = new DealerBranchSetting(
      selectedDealerBranch.dealerBranchId,
      selectedDealerBranch.name
        ? selectedDealerBranch.name
        : selectedDealerBranch.dealerBranchName
    );

    //selectedDealerBranch.branchSetting = dealerBranchSetting;
    selectedDealerBranch.isAdministrator = dealerBranchSetting.isAdministrator;
    selectedDealerBranch.permissions = dealerBranchSetting.permissions;
    selectedDealerBranch.name = dealerBranchSetting.name;

    var dealerGroup = this.props.dealerGroup;
    if (dealerGroup.dealerBranchAuthorization === undefined) {
      dealerGroup.dealerBranchAuthorization = [];
    }
    dealerGroup.dealerBranchAuthorization.push(selectedDealerBranch);
    this.props.handleAuthorizedDealerGroupSettingChanged(dealerGroup);
  };

  onDealerBranchSettingChange = (dealerBranchSetting, isUpdate) => {
    var dealerGroup = this.props.dealerGroup;
    const selectedDealerBranch = dealerGroup.dealerBranchAuthorization.find(
      (x) => x.dealerBranchId === dealerBranchSetting.dealerBranchId
    );

    //selectedDealerBranch.branchSetting = dealerBranchSetting;
    selectedDealerBranch.isAdministrator = dealerBranchSetting.isAdministrator;
    selectedDealerBranch.permissions = dealerBranchSetting.permissions;
    selectedDealerBranch.name = dealerBranchSetting.name;

    dealerGroup.dealerBranchAuthorization =
      dealerGroup.dealerBranchAuthorization.map((el) =>
        el.dealerBranchId === dealerBranchSetting.dealerBranchId
          ? selectedDealerBranch
          : el
      );
    this.props.handleAuthorizedDealerGroupSettingChanged(dealerGroup);
  };

  onChangeIsDealerAdmin(value) {
    var dealerGroup = this.props.dealerGroup;
    dealerGroup.isDealerAdmin = value;

    if (dealerGroup.isDealerAdmin) {
      dealerGroup.dealerBranchAuthorization = [];
      dealerGroup.dealerBranches.forEach((branch) => {
        var branchSetting = new DealerBranchSetting(
          branch.dealerBranchId,
          branch.name ? branch.name : branch.dealerBranchName
        );
        branchSetting.isAdministrator = true;
        branchSetting.permissions = [];
        this.props.permissions.dealerBranch.forEach((perm) => {
          branchSetting.permissions.push(perm.value);
        });
        dealerGroup.dealerBranchAuthorization.push(branchSetting);
      });
    } else {
      dealerGroup.dealerBranchAuthorization = [];
    }
    this.props.handleAuthorizedDealerGroupSettingChanged(dealerGroup);
  }

  onUnAuthorizeDealerBranchClicked = (branchId) => {
    var dealerGroup = this.props.dealerGroup;

    dealerGroup.dealerBranchAuthorization.forEach((branch, index) => {
      if (branch.dealerBranchId === branchId) {
        dealerGroup.dealerBranchAuthorization.splice(index, 1);
      }
    });

    if (dealerGroup.defaultDealerBranchId === branchId) {
      dealerGroup.defaultDealerBranchId = null;
    }

    this.props.handleAuthorizedDealerGroupSettingChanged(dealerGroup);
  };

  onDefaultDealerBranchChange(defaultbranchId) {
    var dealerGroup = this.props.dealerGroup;
    dealerGroup.defaultDealerBranchId = defaultbranchId;
    this.props.handleAuthorizedDealerGroupSettingChanged(dealerGroup);
  }

  updateEnabledEmailTemplateTypes(type, checked) {
    const { dealerGroup } = this.props;

    if (dealerGroup.enabledEmailTemplateTypes === undefined) {
      dealerGroup.enabledEmailTemplateTypes = [];
    }

    if (checked) {
      dealerGroup.enabledEmailTemplateTypes.push(type);
    } else {
      dealerGroup.enabledEmailTemplateTypes.forEach((checkType, index) => {
        if (checkType === type) {
          dealerGroup.enabledEmailTemplateTypes.splice(index, 1);
        }
      });
    }

    this.props.handleAuthorizedDealerGroupSettingChanged(dealerGroup);
  }

  render() {
    const { dealerGroup, enabledRemove } = this.props;
    return (
      <div className="card mb-4 box-shadow">
        <div className="card-header">
          <div className="clearfix">
            <h5 className={` ${enabledRemove ? 'pull-left mb-0' : ''}`}>
              {dealerGroup.name}
            </h5>
            {enabledRemove && (
              <button
                onClick={this.handleExpand}
                type="button"
                className="btn btn-link p-0 ms-3"
              >
                {this.state.expanded ? 'collapse' : 'expand'}
              </button>
            )}
            {enabledRemove && (
              <button
                onClick={this.removeGroup}
                type="button"
                className="pull-right btn btn-link p-0"
              >
                remove
              </button>
            )}
            <div
              className={`collapse pt-3 ${
                this.state.expanded ? 'd-block' : ''
              }`}
            >
              <div>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <FormCheckBox
                      label="Dealer Administrator"
                      checkboxLabel="User is an administrator of all dealer branches"
                      checked={dealerGroup.isDealerAdmin}
                      onChange={this.onChangeIsDealerAdmin}
                    />
                  </div>
                </div>
                {this.props.isDealerAdmin ? (
                  <div className="row">
                    <div className="col-md-12 form-group mb-0">
                      <label className="form-label me-2">
                        Authorized Dealer Branches
                      </label>
                      <br />
                      <Alert color="primary">
                        <i className="fa fa-info-circle fa-lg text-primary" />{' '}
                        This user has full access to all dealer branches
                      </Alert>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="row">
                      <div className="col-md-12 form-group mb-0">
                        <label className="form-label">
                          Authorized Dealer Branches
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6 form-group">
                        <Dropdown
                          placeholder="Add an authorized dealer branch..."
                          items={this.state.unAuthorizedDealerBranches.map(
                            (x) => ({
                              id: x.dealerBranchId,
                              label: x.name ? x.name : x.dealerBranchName,
                            })
                          )}
                          selectedId={this.state.selectedId}
                          onChange={(selectedId) =>
                            this.handleAddDealerBranch(selectedId)
                          }
                          className="w-full"
                        />
                      </div>
                    </div>
                    {this.props.dealerBranchAuthorization !== undefined && (
                      <div className="form-row">
                        {this.props.dealerBranchAuthorization.map(
                          (branch, index) => (
                            <AuthorizedDealerBranchSettingCard
                              key={branch.dealerBranchId}
                              dealerBranchSetting={branch}
                              permissions={this.props.permissions}
                              dealerBranchSettingChange={
                                this.onDealerBranchSettingChange
                              }
                              unauthorizeDealerBranchClick={
                                this.onUnAuthorizeDealerBranchClicked
                              }
                              dealerGroup={dealerGroup}
                            />
                          )
                        )}
                      </div>
                    )}
                  </div>
                )}
                {
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <FormDropdown
                        placeholder="Select a dealer branch..."
                        label="Default Dealer Branch"
                        items={this.state.authorizedDealerBranches.map((x) => ({
                          id: x.dealerBranchId,
                          label: x.name,
                        }))}
                        selectedId={dealerGroup.defaultDealerBranchId}
                        onChange={(defaultDealerBranchId) =>
                          this.onDefaultDealerBranchChange(
                            defaultDealerBranchId
                          )
                        }
                        required
                      />
                    </div>
                  </div>
                }
                <div className="row">
                  <div className="col">
                    <FormGroup>
                      <Label className="form-label">
                        Enabled Notification Types
                      </Label>
                      {dealerGroup &&
                        !dealerGroup.isEmailCommunicationEnabled && (
                          <div>
                            <Alert color="primary">
                              <i className="fa fa-info-circle fa-lg text-primary" />{' '}
                              Email notifications are disabled for this Dealer
                              Group
                            </Alert>
                          </div>
                        )}
                      {this.props.availableEmailTemplateTypes.map((x) => (
                        <div key={x.type}>
                          <Input
                            id={`${dealerGroup.dealerGroupId}-${x.type}`}
                            type="checkbox"
                            checked={dealerGroup.enabledEmailTemplateTypes.includes(
                              x.type
                            )}
                            onChange={(e) =>
                              this.updateEnabledEmailTemplateTypes(
                                x.type,
                                e.target.checked
                              )
                            }
                          />
                          <Label for={`${dealerGroup.dealerGroupId}-${x.type}`}>
                            {x.name}
                          </Label>
                        </div>
                      ))}
                    </FormGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
